import { render, staticRenderFns } from "./regulation-details.vue?vue&type=template&id=7233c31e&scoped=true&"
import script from "./regulation-details.vue?vue&type=script&lang=js&"
export * from "./regulation-details.vue?vue&type=script&lang=js&"
import style0 from "./regulation-details.vue?vue&type=style&index=0&id=7233c31e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7233c31e",
  null
  
)

export default component.exports